import React, { Component } from "react";
import { connect } from "react-redux";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { withRouter } from "react-router-dom";
import Video from 'twilio-video';
import VideoVisitLaunchBtn from "./VideoVisitLaunchBtn";
import VideoVisitBrowserMsgs from "./VideoVisitBrowserMsgs";
import VideoVisitRoomMsgs from "./VideoVisitRoomMsgs";
import VideoVisitRoomClosed from "./VideoVisitRoomClosed";

const TIME_FORMAT = "LT";
const VIDEO_VISIT_CLOSED = "ROOM_CLOSE";
const VIDEO_VISIT_IN_PROGRESS = ["IN_PROGRESS"];

class VideoVisitLaunch extends Component {

    constructor(props) {
        super(props);
        var bClientSide = (typeof window !== "undefined");
        if (bClientSide) {
            this.state = {
                enableLaunchButton: this.canEnableVideoVisit,
                roomOpensTime: "",
                roomClosingTime: "",
                roomTimePassed: false
            };
        }
        this.updateLaunchButtonStatus = this.updateLaunchButtonStatus.bind(this);
        const me = this;
        // set a timer to enable the launch button when it's time for the visit to start, and disable it when the visit has expired.
        this.timer = setInterval(() => {
            // only update state when a change occurs...
            me.updateLaunchButtonStatus();
        }, 5000);

        this.isWebSupportedBrowser = Video.isSupported;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisitLaunch.ComponentDidMount", new Date(), Tools.getURLPath());
        this.updateLaunchButtonStatus();
    }

    componentDidUpdate(prevProps) {
        const currentPatientName = this.props.appointmentDetails && this.props.appointmentDetails.patientName ? this.props.appointmentDetails.patientName : "";
        const prevPatientName = prevProps.appointmentDetails && prevProps.appointmentDetails.patientName ? prevProps.appointmentDetails.patientName : "";
        if (currentPatientName !== prevPatientName) {
            this.updateLaunchButtonStatus();
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    updateLaunchButtonStatus() {
        this.canEnableVideoVisit = this.isTimeToStartVideoVisit();
        const { enableLaunchButton, roomTimePassed } = this.state;
        const { isRequireEcheckin, eCheckinCompleted, informLaunchBtnStatus } = this.props;
        if (enableLaunchButton !== this.canEnableVideoVisit) {
            this.setState({ enableLaunchButton: this.canEnableVideoVisit });
            const isButtonEnabled = this.canEnableVideoVisit ? isRequireEcheckin ? eCheckinCompleted : true : false;
            const currentTimeInCST = Tools.getCentralDateWithFormat(new Date(), "MM-DD-YYYY HH:mm:ss");
            logUI(`MBHWeb.UI.VideoVisit.LaunchButton.${isButtonEnabled ? "Enabled" : "Disabled"}`, new Date(), Tools.getURLPath(),
                {
                    "isTimeToStartVisit": this.canEnableVideoVisit,
                    "isRequireEcheckin": isRequireEcheckin,
                    "isECheckinCompleted": eCheckinCompleted,
                    "currentTimeInCST": currentTimeInCST
                });
            if (informLaunchBtnStatus) {
                informLaunchBtnStatus(this.canEnableVideoVisit, roomTimePassed);
            }
        }
    }

    isVideoVisitToday() {
        const appointmentDetails = this.props.appointmentDetails;
        let isVisitToday = false;
        if (appointmentDetails && appointmentDetails.appointmentDateTime) {
            isVisitToday = Tools.isVisitToday(appointmentDetails.appointmentDateTime);
        }
        return isVisitToday;
    }

    isTimeToStartVideoVisit() {
        const videoVisit = this.props.appointmentDetails;
        const visitsEnabled = window.serverData.data.ambulatoryVideoVisitEnabled;
        var ret = false;

        if (visitsEnabled && videoVisit && videoVisit.appointmentDateTime) {
            // const minutesBefore = window.serverData.data.videoVisitEnabledMinutesBeforeStart;
            //const minutesAfter = window.serverData.data.videoVisitEnabledMinutesAfterStart;
            const { videoVisitEnabledMinutesBeforeStart, videoVisitEnabledMinutesAfterStart,
                SDCVisitEnabledMinutesBeforeStart, SDCVisitEnabledMinutesAfterStart } = this.props;
            const minutesBefore = this.props.isSDCVisit ? SDCVisitEnabledMinutesBeforeStart : videoVisitEnabledMinutesBeforeStart;
            const minutesAfter = this.props.isSDCVisit ? SDCVisitEnabledMinutesAfterStart : videoVisitEnabledMinutesAfterStart;

            const visitDateTimeBefore = Tools.subtractMinutesFromDate(videoVisit.appointmentDateTime, minutesBefore);//apptDateTime.clone().subtract(minutesBefore,"minutes");
            const visitDateTimeAfter = Tools.addMinutesToDate(videoVisit.appointmentDateTime, minutesAfter);//apptDateTime.clone().add(minutesAfter, "minutes");

            // get room open time            
            this.setState({ roomOpensTime: Tools.formatCentralDate(visitDateTimeBefore, TIME_FORMAT), roomClosingTime: Tools.formatCentralDate(visitDateTimeAfter, TIME_FORMAT) });

            // check the date
            if (this.isVideoVisitToday()) {
                if (Tools.isBetween(visitDateTimeBefore, visitDateTimeAfter)) {
                    ret = true;
                    this.setState({ roomTimePassed: false });
                }
                else if (Tools.isAfter(visitDateTimeAfter)) {
                    this.setState({ roomOpensTime: "", roomClosingTime: "", roomTimePassed: true });
                } else {
                    this.setState({ roomTimePassed: false });
                }
            }
        }

        return ret;
    }

    render() {
        const { appointmentDetails, isRequireEcheckin, eCheckinCompleted, videoVisitLinks, isMobile, isSDCVisit, ssoBaseUrl } = this.props;
        const { roomOpensTime, roomTimePassed, enableLaunchButton, roomClosingTime } = this.state;
        const roomClosed = appointmentDetails && appointmentDetails.roomStatus && appointmentDetails.roomStatus === VIDEO_VISIT_CLOSED;
        const roomInProgress = (appointmentDetails && appointmentDetails.roomStatus && VIDEO_VISIT_IN_PROGRESS.indexOf(appointmentDetails.roomStatus) > -1) ? (isRequireEcheckin ? eCheckinCompleted : true) : false;
        const launchRequirementsComplete = enableLaunchButton === true ? isRequireEcheckin ? eCheckinCompleted : true : false;

        return (
            <React.Fragment>
                {roomClosed || (!this.state.enableLaunchButton && roomTimePassed)
                    ? <VideoVisitRoomClosed />
                    : <React.Fragment>
                        {!this.isWebSupportedBrowser
                            ? <VideoVisitBrowserMsgs
                                ssoBaseUrl={ssoBaseUrl}
                            />
                            : <React.Fragment>
                                {(launchRequirementsComplete || roomInProgress || (eCheckinCompleted && !enableLaunchButton))
                                    ? <VideoVisitLaunchBtn
                                        props={this.props}
                                        appointmentDetails={appointmentDetails}
                                        disabled={!enableLaunchButton}
                                        isMobile={isMobile}
                                        isSDCVisit={isSDCVisit}
                                        roomClosingTime={roomClosingTime}
                                        videoVisitLinks={videoVisitLinks}
                                    />
                                    : <VideoVisitRoomMsgs
                                        appointmentDetails={appointmentDetails}
                                        eCheckinCompleted={eCheckinCompleted}
                                        isSDCVisit={isSDCVisit}
                                        roomOpensTime={roomOpensTime}
                                        roomClosingTime={roomClosingTime}
                                        enableLaunchButton={enableLaunchButton}
                                        roomTimePassed={roomTimePassed}
                                    />
                                }

                            </React.Fragment>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }



}

const mapStateToProps = (state) => {
    return {
        videoVisitEnabledMinutesBeforeStart: state.session.serverData && state.session.serverData.videoVisitEnabledMinutesBeforeStart ? state.session.serverData.videoVisitEnabledMinutesBeforeStart : "30",
        videoVisitEnabledMinutesAfterStart: state.session.serverData && state.session.serverData.videoVisitEnabledMinutesAfterStart ? state.session.serverData.videoVisitEnabledMinutesAfterStart : "45",
        SDCVisitEnabledMinutesBeforeStart: state.session.serverData && state.session.serverData.SDCVisitEnabledMinutesBeforeStart ? state.session.serverData.SDCVisitEnabledMinutesBeforeStart : "5",
        SDCVisitEnabledMinutesAfterStart: state.session.serverData && state.session.serverData.SDCVisitEnabledMinutesAfterStart ? state.session.serverData.SDCVisitEnabledMinutesAfterStart : "10",
        visitTypeForSDC: state.session.serverData && state.session.serverData.visitTypeForSDC ? state.session.serverData.visitTypeForSDC : "60148",
        ssoBaseUrl: state.session.serverData ? state.session.serverData.ssoBaseURL : "",
        videoVisitLinks: state.dashboard?.videoVisitLinks
    };
};

export default withRouter(connect(mapStateToProps, null)(VideoVisitLaunch));


